module.exports = __webpack_public_path__ + "img/content-management.d2d5b8c8.svg";